'use client';

import { Box, IconButton, Paper, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import { useLanguage } from '../../../utils/i18n';

export default function MapSidebar({ isOpen, onToggle, children }) {
  const { t } = useLanguage();
  const sidebarWidth = 300;

  return (
    <Paper
      // elevation={4}
      // square
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: sidebarWidth,
        height: '100%',
        transform: isOpen ? 'translateX(0)' : `translateX(${sidebarWidth}px)`,
        transition: 'transform 0.3s ease-in-out',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#ffffff',
        color: '#fff'
      }}
    >
      <IconButton
        onClick={onToggle}
        sx={{
          position: 'absolute',
          left: -40,
          top: 15,
          bgcolor: '#2c3e50',
          color: '#fff',
          borderRadius: '4px 0 0 4px',
          '&:hover': { bgcolor: '#34495e' },
          boxShadow: '-2px 0px 5px rgba(0,0,0,0.2)'
        }}
      >
        {isOpen ? <ChevronRightIcon /> : <ChevronLeftIcon />}
      </IconButton>

      <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 1.5 }}>
        {children ? (
          children
        ) : (
          <Typography variant="body2" color="rgba(255,255,255,0.6)">
            {t('mapsTracking.sidebarContent', 'Konten sidebar akan dimuat di sini...')}
          </Typography>
        )}
      </Box>
    </Paper>
  );
}
